const messages = {
  title: "Campagnes de vente",
  desc: "Utilisez activement nos campagnes de vente avec vos clients. Vous pouvez bien entendu proposer les deux campagnes à vos clients. En savoir plus sur la Garantie pneus et la campagne Drive Our Best ci-dessous.",
  participation: {
    title: "Demandez à participer dès maintenant",
    desc: "Vous souhaitez mettre en œuvre une ou plusieurs de nos campagnes dans votre magasin ? Vous pouvez alors demander à participer ici. Votre entreprise sera activée pour la ou les campagne(s) et vous recevrez sous 4 semaines du matériel publicitaire pour soutenir vos ventes.<br/><br/>Faites votre choix :",
    request: "DEMANDER À PARTICIPER",
    success: "Merci, votre demande a été envoyée",
  },
};
export default {
  messages,
};
